import React from "react";
import "../styles/About.css";
import BlurText from "../components/BlurText";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Import corect pentru imagini
import c1 from "../assets/about/c1.jpg";
import c2 from "../assets/about/c2.jpg";
import c3 from "../assets/about/c3.jpg";
import c4 from "../assets/about/c4.jpg";
import c5 from "../assets/about/c5.jpeg";

function About() {
  const { t } = useTranslation("about");

  return (
    <section className="about-page">
      <header className="about-hero no-image">
        <div className="about-hero-content">
          <BlurText
            text={t("title")}
            className="about-hero-title"
            animateBy="words"
            delay={90}
          />
          <p className="about-hero-subtitle">{t("subtitle")}</p>
        </div>
      </header>

      <section className="about-stats">
        <div className="stat-card">
          <div className="stat-number">1000+</div>
          <div className="stat-label">{t("stats.dogs")}</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">50+</div>
          <div className="stat-label">{t("stats.cats")}</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">650+</div>
          <div className="stat-label">{t("stats.adoptions")}</div>
        </div>
        <div className="stat-card">
          <div className="stat-number">200+</div>
          <div className="stat-label">{t("stats.sterilizations")}</div>
        </div>
      </section>

      <section className="about-chapters">
        <div className="chapter">
          <img src={c1} className="chapter-image" alt="" />
          <div className="chapter-content">
            <h3 className="chapter-title">{t("chapters.c1Title")}</h3>
            <p className="chapter-text">{t("p1")}</p>
          </div>
        </div>

        <div className="chapter">
          <img src={c2} className="chapter-image" alt="" />
          <div className="chapter-content">
            <h3 className="chapter-title">{t("chapters.c2Title")}</h3>
            <p className="chapter-text">{t("p2")}</p>
          </div>
        </div>

        <div className="chapter">
          <img src={c3} className="chapter-image" alt="" />
          <div className="chapter-content">
            <h3 className="chapter-title">{t("chapters.c3Title")}</h3>
            <p className="chapter-text">{t("p3")}</p>
          </div>
        </div>

        <div className="chapter">
          <img src={c4} className="chapter-image" alt="" />
          <div className="chapter-content">
            <h3 className="chapter-title">{t("chapters.c4Title")}</h3>
            <p className="chapter-text">{t("p4")}</p>
          </div>
        </div>

        <div className="chapter">
          <img src={c5} className="chapter-image" alt="" />
          <div className="chapter-content">
            <h3 className="chapter-title">{t("chapters.c5Title")}</h3>
            <p className="chapter-text">{t("p5")}</p>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="cta-card">
          <h2>{t("ctaTitle")}</h2>
          <p>{t("p6")}</p>
          <Link to="/help" className="cta-button">
            {t("ctaButton")}
          </Link>
          <Link to="/contact" className="cta-button">
            {t("contactButton")}
          </Link>
        </div>
      </section>
    </section>
  );
}

export default About;
